// Global safety polyfills for older mobile Safari (iOS < 15.4).
// Must be imported BEFORE any other module so that all dependencies
// (react-query, framer-motion, sonner, etc.) inherit safe globals.

(function installPolyfills() {
  if (typeof window === "undefined") return;

  // 1) crypto.randomUUID polyfill — iOS Safari < 15.4 does not ship it.
  try {
    const c = window.crypto || window.msCrypto;
    if (c && typeof c.randomUUID !== "function") {
      const getRandomValues = c.getRandomValues
        ? c.getRandomValues.bind(c)
        : null;
      Object.defineProperty(c, "randomUUID", {
        configurable: true,
        writable: true,
        value: function randomUUID() {
          // Prefer crypto.getRandomValues if available, fall back to Math.random.
          let bytes;
          if (getRandomValues) {
            bytes = new Uint8Array(16);
            getRandomValues(bytes);
          } else {
            bytes = new Array(16);
            for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
          }
          // Per RFC4122 v4
          bytes[6] = (bytes[6] & 0x0f) | 0x40;
          bytes[8] = (bytes[8] & 0x3f) | 0x80;
          const hex = [];
          for (let i = 0; i < 16; i++) {
            hex.push((bytes[i] + 0x100).toString(16).substr(1));
          }
          return (
            hex[0] + hex[1] + hex[2] + hex[3] + "-" +
            hex[4] + hex[5] + "-" +
            hex[6] + hex[7] + "-" +
            hex[8] + hex[9] + "-" +
            hex[10] + hex[11] + hex[12] + hex[13] + hex[14] + hex[15]
          );
        },
      });
    }
  } catch (_) {
    // Some sandboxes freeze window.crypto; ignore — uid() helper still works.
  }

  // 2) globalThis polyfill — iOS Safari < 12.1 does not expose globalThis.
  try {
    if (typeof globalThis === "undefined") {
      // eslint-disable-next-line no-extend-native
      Object.defineProperty(Object.prototype, "__magic__", {
        get: function () { return this; },
        configurable: true,
      });
      // eslint-disable-next-line no-undef
      __magic__.globalThis = __magic__;
      delete Object.prototype.__magic__;
    }
  } catch (_) { /* noop */ }
})();
